<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input v-model="getMicrolectureTypeList_data.mtName" placeholder="请输入类型" clearable size='small'
          style="max-width:200px;" />
        <el-select v-model='getMicrolectureTypeList_data.mtmId' clearable placeholder="请输入分类" size='small'
          style="max-width:200px;">
          <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId" :label="item.mtmName"
            :value="item.mtmId"></el-option>
        </el-select>
        <el-button v-click.getMicrolectureTypeList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addMicrolectureType" @click=" $form('addMicrolectureType')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加微课
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getMicrolectureTypeList' api='getMicrolectureTypeList'
      xupdateapi='updateMicrolectureType' :height="H - 165">
    </mytable>

    <myform :viewobj='{
        addMicrolectureType: ["新增微课信息", "el-icon-circle-plus"],
        updateMicrolectureType: ["修改微课信息", "el-icon-edit-outline"],
        $succeed$: getMicrolectureTypeList
      }' @closed="$form('updateMicrolectureType', 'reset')">
      <template v-slot:mtmId="{ Myformdata }">
        <el-select v-model='Myformdata.mtmId' clearable>
          <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId" :label="item.mtmName"
            :value="item.mtmId"></el-option>
        </el-select>
      </template>
      <hide slot='mtId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainType: [],
      mtId: null,
      theMtId: "",
      getMicrolectureTypeMainList_data: [],
      tableColums_getMicrolectureTypeList: {
        $selection: false,

        mtName: '标题',
        mtmName: '大分类',
        mtOrder: '排序',
        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateMicrolectureType && `@text: 编辑#warn
           @click: $form("updateMicrolectureType",$row)
          `,
          this.deleteMicrolectureType && `@text: 删除#danger
           @click: _confirm('确定要删除该微课吗?')
                   .trigger('deleteMicrolectureType',{mtId:$row.mtId})
                   .trigger('getMicrolectureTypeList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
  },

  async created() {
    this.getMicrolectureTypeMainLists().result((res) => {
      if (res.data.data) {
        console.log(res.data.data);
        this.getMicrolectureTypeMainList_data = res.data.data
      }
    }) 
    this.getMicrolectureTypeList();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/help/MicrolectureTypeManage.vue